<template>
  <div>
    <wc-data-box
      :title='toolbarData.title'
      :titleIcon='toolbarData.icon'
      :titleIconColor='toolbarData.color'
      :loading='isLoading'
      :mini='mini'
      :showAdd='!wo.archived && !wo.office_complete'
      @add='openAdd'
    >
      <v-card flat v-if='logs.length === 0'>
        <v-card-text>
          No logs.
        </v-card-text>
      </v-card>
      <template v-for='(l, index) in sortedLogs'>
        <v-divider v-if='index > 0' :key='l.id'></v-divider>
        <v-card flat :key="index + '-' + l.id" @click='editLog(l)'>
          <v-card-subtitle class='pb-2 d-flex align-baseline'>
            <wc-avatar :profile='l.created_by_obj'></wc-avatar>
            <span class='mx-2 heading-6'>{{ l.date | shortDate }}</span>
            <small v-if='l.time'>{{ l.time | time }}</small>
          </v-card-subtitle>
          <v-card-text>
            <span class='black--text'>{{ l.notes }}</span>
          </v-card-text>
        </v-card>
      </template>
    </wc-data-box>

    <wc-dialog
      :showDialog='showDialog'
      :title='toolbarData.title'
      :icon='toolbarData.icon'
      :iconColor='toolbarData.color'
      :disableButtons='isSaving || !isFormValid'
      @cancel='showDialog = false'
      @save='saveLog'
    >
      <v-form v-model='isFormValid'>
        <p class='caption mb-4' v-if='!logCopy.id'>Date and time will be automatically set when you create this entry</p>
        <!-- <wc-datepicker label='Log date' required v-model='logCopy.date'></wc-datepicker> -->
        <v-textarea
          label='Log notes'
          outlined
          v-model='logCopy.notes'
        ></v-textarea>
      </v-form>
    </wc-dialog>
  </div>
</template>

<script>
import wosAPI from '../../api/'
import miscServices from '@/services/misc'
import _ from 'lodash'
import moment from 'moment'

export default {
  name: 'wo-scheduling-log',
  props: {
    wo: {
      required: true
    },
    mini: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isLoading: false,
    isSaving: false,
    isFormValid: false,
    showDialog: false,
    logs: [],
    logCopy: {
      date: null,
      work_order: null,
      created_by: null,
      notes: ''
    }
  }),
  computed: {
    toolbarData () {
      return {
        title: 'Scheduling Log',
        icon: 'mdi-clipboard-text',
        color: 'cyan'
      }
    },
    sortedLogs () {
      return _.orderBy(this.logs, ['date', 'time'], ['desc', 'desc'])
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      this.isLoading = true
      this.logs = await wosAPI.getSchedulingLogForWO(this.wo.id)
      this.isLoading = false
    },
    openAdd () {
      this.logCopy.id = null
      this.logCopy.date = moment().format('YYYY-MM-DD').toString()
      this.logCopy.work_order = this.wo.id
      this.logCopy.created_by = this.$store.state.auth.profile.id
      this.logCopy.notes = ''
      this.showDialog = true
    },
    editLog (l) {
      this.logCopy = _.cloneDeep(l)
      this.showDialog = true
    },
    async saveLog () {
      this.isSaving = true
      if (this.logCopy.id) {
        let tmp = await wosAPI.updateSchedulingLog(this.logCopy)
        this.logs = miscServices.replaceObject(this.logs, tmp)
      } else {
        let tmp = await wosAPI.createSchedulingLog(this.logCopy)
        this.logs.push(tmp)
      }
      this.showDialog = false
      this.isSaving = false
    }
  }
}
</script>
